import React from 'react'
import { ControlledSelectField } from '../ControlledSelectField'

export const BankSelect = () => {
  const menuItems = [
    {
      value: 'Asia United Bank (AUB)',
      label: 'Asia United Bank (AUB)'
    },
    {
      value: 'Banco De Oro (BDO)',
      label: 'Banco De Oro (BDO)'
    },
    { value: 'Bank of Commerce', label: 'Bank of Commerce' },
    {
      value: 'Bank of the Philippine Islands (BPI)',
      label: 'Bank of the Philippine Islands (BPI)'
    },
    {
      value: 'BPI Family Savings',
      label: 'BPI Family Savings'
    },
    { value: 'China Bank Savings', label: 'China Bank Savings' },
    {
      value: 'China Banking Corporation (Chinabank)',
      label: 'China Banking Corporation (Chinabank)'
    },
    { value: 'Citibank', label: 'Citibank' },
    {
      value: 'Development Bank of the Philippines',
      label: 'Development Bank of the Philippines'
    },
    {
      value: 'EastWest Bank',
      label: 'EastWest Bank'
    },
    {
      value: 'Landbank',
      label: 'Landbank'
    },
    {
      value: 'Maybank',
      label: 'Maybank'
    },
    {
      value: 'Metrobank',
      label: 'Metrobank'
    },
    {
      value: 'Philippine Bank of Communications (PBCom)',
      label: 'Philippine Bank of Communications (PBCom)'
    },
    {
      value: 'Philippine National Bank (PNB)',
      label: 'Philippine National Bank (PNB)'
    },
    {
      value: 'Philippine Savings Bank (PSBank)',
      label: 'Philippine Savings Bank (PSBank)'
    },
    { value: 'RCBC Savings Bank', label: 'RCBC Savings Bank' },
    {
      value: 'Rizal Commercial Banking Corporation (RCBC)',
      label: 'Rizal Commercial Banking Corporation (RCBC)'
    },
    { value: 'Robinsons Bank', label: 'Robinsons Bank' },
    { value: 'Security Bank', label: 'Security Bank' },
    { value: 'Sterling Bank of Asia', label: 'Sterling Bank of Asia' },
    { value: 'Unionbank', label: 'Unionbank' },
    {
      value: 'United Coconut Planters Bank (UCPB)',
      label: 'United Coconut Planters Bank (UCPB)'
    },
    {
      value: 'Other (e.g., GCash/PayMaya)',
      label: 'Other (e.g., GCash/PayMaya)'
    }
  ]

  return (
    <ControlledSelectField name='bank' label='Bank' menuItems={menuItems} />
  )
}
